<template>
  <a-modal
    :title="'发送的事中风控编号：' + this.model['number']"
    :width="880"
    :visible="visible"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="风控提示">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                show-search
                mode="multiple"
                v-decorator="[
                  'item_ids',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择风控提示"
                @change="handleRiskControlItemChange"
              >
                <a-select-option v-for="d in riskControlItemList" :key="d.id">
                  {{ d.risk_warning_title }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="发送给">
              <a-select
                @change="sendUserTypeChange"
                placeholder="请选择"
                v-decorator="[
                  'received_user_type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in sendUserType">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedUserType === '2'">
            <a-form-item label="部门">
              <a-tree-select
                style="width: 100%"
                allow-clear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="departmentTreeData"
                v-decorator="[
                  'department_id',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择部门"
                @change="departmentChange"
              >
              </a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="selectedUserType === '3'">
            <a-form-item label="自定义人员">
              <a-button icon="plus" @click="handleAddAttachment()">添加</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="visibleUserList">
            <a-form-item label="人员列表">
              <a-spin :spinning="userFetching"></a-spin>
              <a-table
                v-if="this.receivedUserList.length > 0"
                bordered
                :data-source="receivedUserList"
                :columns="attachmentColumns"
                :pagination="false"
                key="key">
                <template slot="url" slot-scope="text">
                  <a :href="text" target="_blank"> {{ text }}</a>
                </template>
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="receivedUserList.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(1, record.id)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    <user-form
      ref="userCreateForm"
      @cancel="handleAddCancel"
      @ok="handleOk"
      :record="mdl"
      :visible="visibleFrom"
      :selected-keys="receivedUserList.map(item => item.id)"
      v-if="visibleFrom"
      :loading="confirmLoading"
      :model="mdl" />
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { project_list } from '@/api/trade_project'
import UserForm from '../modules/UserForm'
import { tradeDepartmentList } from '@/api/trade_department'
import { tradeUserDepartmentList } from '@/api/trade_user'

// 表单字段
const fields = ['id', 'number', 'name', 'cash']
export default {
  components: {
    UserForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
    return {
      userFetching: false,
      sendUserType: {
        1: '采购全流程参与人',
        2: '部门人员',
        3: '自定义人员'
      },
      selectedUserType: undefined,
      visibleUserList: false,
      riskControlItemList: [],
      selectedItemList: [],
      receivedUserList: [],
      departmentTreeData: [],
      form: this.$form.createForm(this),
      visibleFrom: false,
      confirmLoading: false,
      mdl: undefined,
      attachmentColumns: [
        {
          title: '姓名',
          width: 200,
          ellipsis: true,
          dataIndex: 'name'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.model)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  },
  mounted () {
    this.riskControlItemList = this.model['items']
  },
  methods: {
    sendUserTypeChange (value) {
      this.receivedUserList = []
      this.selectedUserType = value
      this.visibleUserList = false
      console.log(value, this.model)
      if (this.selectedUserType === '1') {
        this.visibleUserList = true
        this.handleProjectSearch(this.model['project_id'])
      } else if (this.selectedUserType === '2') {
        this.handleDepartmentSearch()
      }
    },
    handleDepartmentSearch () {
      tradeDepartmentList().then((res) => {
        const result = res.data.entries || []
        this.departmentTreeData = this.buildTree(this.transformDepartments(result))
      })
    },
    transformDepartments (departments) {
      return departments.map(department => ({
        title: department.name,
        value: department.id,
        key: department.id,
        parent_department_id: department.parent_department_id,
        remark: department.remark
      }))
    },
    buildTree (departments) {
      const idToNodeMap = {}
      const tree = []
      // 初始化每个节点
      departments.forEach(department => {
        idToNodeMap[department.key] = { ...department, children: [] }
      })
      // 构建树状结构
      departments.forEach(department => {
        const parentId = department.parent_department_id
        if (parentId === -1) {
          tree.push(idToNodeMap[department.key])
        } else {
          idToNodeMap[parentId].children.push(idToNodeMap[department.key])
        }
      })
      return tree
    },
    handleProjectSearch (id) {
      this.userFetching = true
      project_list({ id: id }).then((res) => {
        const result = res.data.entries || []
        if (result) {
          this.receivedUserList = result[0].participants.map(item => {
            item.id = item.participant_id ? item.participant_id : item.user_id
            item.name = item.nickname ? item.nickname : item.name
            return item
          })
        }
      }).finally(() => {
        this.userFetching = false
      })
    },
    handleRiskControlItemChange (items) {
      this.selectedItemList = items
    },
    departmentChange (departmentId) {
      this.receivedUserList = []
      if (departmentId === undefined) {
        return
      }
      this.visibleUserList = true
      this.userFetching = true
      tradeUserDepartmentList({ department_id: departmentId }).then(res => {
        if (res.code === 1000) {
          console.log(res)
          this.receivedUserList = res.data.entries.map(item => item.user)
        }
      }).finally(() => {
        this.userFetching = false
      })
    },
    onAttachmentDelete (type, key) {
      if (type === 1) {
        const dataSource = [...this.receivedUserList]
        this.receivedUserList = dataSource.filter(item => item.id !== key)
      }
    },
    handleAddAttachment () {
      this.mdl = undefined
      this.visibleFrom = true
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.userCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (user) {
      const form = this.$refs.userCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          // 新增
          console.log(values, user)
          this.visibleUserList = true
          const receivedUserIds = this.receivedUserList.map(item => item.id)
          user = user.filter(item => !receivedUserIds.includes(item.id))
          this.receivedUserList.push(...user)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.receivedUserList.length === 0) {
        this.$message.warning('人员列表为空')
        return
      }
      this.$emit('ok', this.receivedUserList)
    }
  }
}
</script>
